<ng-template #alertModalRef let-activeModal>
  <div class="alert-modal">
    <div class="modal-header">
      <div>
        <i [ngClass]="headerIcon"></i><span>&nbsp;{{ header }}</span>
      </div>
      <button
        cpGTagEvent
        [params]="{ event_label: 'alert_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" *ngIf="!message.IsHtml">
      {{ message.Body }}
    </div>
    <div class="modal-body" *ngIf="message.IsHtml" [innerHtml]="message.Body"></div>
    <div class="modal-footer" *ngIf="!hideOkButton">
      <button
        cpGTagEvent
        [params]="{ event_label: 'alert_modal_ok' }"
        type="button"
        class="btn btn-link"
        (click)="activeModal.close()">
        {{ okBtnText }}
      </button>
    </div>
  </div>
</ng-template>
